import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=bd4baea6&"
import script from "./BackButton.vue?vue&type=script&lang=js&"
export * from "./BackButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd4baea6')) {
      api.createRecord('bd4baea6', component.options)
    } else {
      api.reload('bd4baea6', component.options)
    }
    module.hot.accept("./BackButton.vue?vue&type=template&id=bd4baea6&", function () {
      api.rerender('bd4baea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/devices/shared/components/formcomponents/BackButton.vue"
export default component.exports